import { Modal } from 'flowbite-react';
import { Img } from 'react-image';

interface Props {
	isOpen: boolean;
	onClose: () => void;
}

const LinkedInModal = ({ isOpen, onClose }: Props) => {
	return (
		<Modal show={isOpen} dismissible onClose={onClose}>
			<Modal.Body className="w-full h-full">
				<Img
					className="ml-3 inline-block w-full h-full"
					src={'https://hukumu-test.s3.ap-south-1.amazonaws.com/icons/linkedin-test.png'}
					alt="linkedinscanner"
					width={80}
					height={50}
				/>
			</Modal.Body>
		</Modal>
	);
};

export default LinkedInModal;
